import { PricesFactor } from '@ui/features/Trade/types';

import { useTradeModule } from '../TradeModuleCtx';

// native token
export const useEstOpenLimitGasFee = ({
  disabled = false,
}: {
  disabled: boolean | undefined;
}) => {
  const { openLimitGasFee } = useTradeModule();
  if (disabled) {
    return undefined;
  }
  
return openLimitGasFee;
};